import { render, staticRenderFns } from "./OnboardingFullNameForm.vue?vue&type=template&id=be525b26"
import script from "./OnboardingFullNameForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingFullNameForm.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports